<template>
  <div class="table-space">
    <div class="table-header">
      <div class="add-button">
        <a-button size="small" type="primary" icon="plus"
                  @click="showAddReadingPlanModal">添加读书计划</a-button>
      </div>
      <div class="clear"></div>
    </div>
    <div class="table-content">
      <a-table :columns="columns"
               :dataSource="readingPlans"
               :pagination="false"
               :loading="loading"
               :scroll="{ x: 1000 }"
               :rowKey="record => record.id"
               @change="tableChange()" >
        <template slot="status" slot-scope="text">
          <span href="javascript:;" style="color: coral" v-if="text === '未开始'">{{text}}</span>
          <span href="javascript:;" style="color: #52c41a" v-else-if="text === '在读'" >
            {{text}}</span>
          <span href="javascript:;" style="color: #b90b14" v-else>{{text}}</span>
        </template>
        <span slot="action" slot-scope="record">
           <a href="javascript:;"
              v-on:click="toReaderDetail(record.key)">人员管理</a>
          <a-divider type="vertical" />
           <a href="javascript:;"
              v-on:click="showEditReadingPlanModal(record.key)">编辑</a>
           <a-divider type="vertical" />
          <a href="javascript:;"
             v-on:click="downloadCert(record.key)">下载证书</a>
          <a-divider type="vertical" />
                  <a href="javascript:;"
                     v-on:click="downloadPdf(record.key)">下载pdf</a>

         </span>
      </a-table>
    </div>
    <a-modal
      title="添加读书计划"
      :visible="addReadingPlanVisible"
      @ok="handleAddReadingPlanOk"
      :confirmLoading="confirmLoading"
      @cancel="handleAddReadingPlanCancel"
    >
      <a-form
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item v-bind="formItemLayout">
          <span slot="label">要读的书</span>
          <a-select
            showSearch
            placeholder="选择一本书"
            optionFilterProp="children"
            style="width: 310px"
            @focus="handleFocus"
            @blur="handleBlur"
            @change="handleChange"
            :filterOption="filterOption"
            v-decorator="['bookId',
            {
              rules: [{ required: true, message: '请选择一本书!'}],
            }]"
          >
            <a-select-option v-for="d in books" :key="d.id" :value="d.id">
              {{d.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">教师</span>
          <a-select
            showSearch
            placeholder="选择教师"
            optionFilterProp="children"
            style="width: 310px"
            @focus="handleFocus"
            @blur="handleBlur"
            @change="handleChange"
            :filterOption="filterOption"
            v-decorator="['teacherId',
            {
              rules: [{ required: true, message: '请选择一名教师!'}],
            }]"
          >
            <a-select-option v-for="d in teachers" :key="d.id" :value="d.id">
              {{d.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="开始时间">
          <a-date-picker @change="changeStartTime"
                         style="width: 100%" placeholder="选择开始时间" v-decorator="['startTime',
            {
              rules: [{ required: true, message: '请选择开始时间!'}],
            }]" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="结束时间">
          <a-date-picker @change="changeEndTime"
                         style="width: 100%" placeholder="选择结束时间" v-decorator="['endTime',
            {
              rules: [{ required: true, message: '请选择结束时间!'}],
            }]" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">每个周期天数</span>
          <a-input-number id="inputNumber" :min="1" :max="100"
                          @change="cycleDaysChange"
                          v-decorator="['cycleDays',
            { initialValue: '7',
              rules: [{ required: true, message: '请选择学习周期!'}],
            }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">暂停周期数目</span>
          <a-input-number id="pauseCycleCount" :min="0" :max="100"
                          @change="cycleDaysChange"
                          v-decorator="['pauseCycleCount',
            { initialValue: '0',
              rules: [{ required: true, message: '请选择学习周期!'}],
            }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">反馈提示</span>
          <a-radio-group v-decorator="['notifyComment',
          {initialValue: 'true',}
          ]">
            <a-radio-button value="true">
               是
            </a-radio-button>
            <a-radio-button value="false">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">班主任提示</span>
          <a-radio-group v-decorator="['adminMustComment',
          {initialValue: 'true',}
          ]">
            <a-radio-button value="true">
              是
            </a-radio-button>
            <a-radio-button value="false">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">教师必须反馈</span>
          <a-radio-group v-decorator="['teacherMustComment',
          {initialValue: 'false',}
          ]">
            <a-radio-button value="true">
              是
            </a-radio-button>
            <a-radio-button value="false">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <!--<a-form-item v-bind="formItemLayout">-->
          <!--<span slot="label">助教IDS</span>-->
          <!--<a-input v-decorator="['otherNotifiers',-->
            <!--{-->
              <!--rules: [{ required: false, message: '请输入的助教ID!'}],-->
            <!--}-->
           <!--]"/>-->
        <!--</a-form-item>-->
        <a-form-item v-bind="formItemLayout">
          <span slot="label">自定义名称</span>
          <a-input v-decorator="['customizedName',
            {
              rules: [{ required: false, message: '请输入的自定义名称!'}],
            }
           ]"/>
        </a-form-item>
        <!--<a-form-item v-bind="formItemLayout">-->
          <!--<span slot="label">退出学员ID</span>-->
          <!--<a-input v-decorator="['inactiveStudentIds',-->
            <!--{-->
              <!--rules: [{ required: false, message: '请输入的退出学员ID!'}],-->
            <!--}-->
           <!--]"/>-->
        <!--</a-form-item>-->
        <!--<a-form-item v-bind="formItemLayout">-->
          <!--<span slot="label">微信提示周期</span>-->
          <!--<a-input-number id="wechatCycleDays" :min="0" :max="100"-->
                          <!--@change="cycleDaysChange"-->
                          <!--v-decorator="['wechatCycleDays',-->
            <!--{ initialValue: '0',-->
              <!--rules: [{ required: true, message: '请选择微信提示周期!'}],-->
            <!--}]"-->
          <!--/>-->
        <!--</a-form-item>-->
      </a-form>
      <!--<a-form-item v-bind="formItemLayout" label="微信提示时间">-->
        <!--<a-date-picker @change="changeWechatStartTime"-->
                       <!--style="width: 100%" placeholder="选择
                       提示开始时间" v-decorator="['wechatStartTime',-->
            <!--{-->
              <!--rules: [{ required: false, message: '请选择提示开始时间!'}],-->
            <!--}]" />-->
      <!--</a-form-item>-->
    </a-modal>
    <a-modal
      title="编辑读书计划"
      :visible="editReadingPlanVisible"
      @ok="handleEditReadingPlanOk"
      :confirmLoading="confirmLoading"
      @cancel="handleEditReadingPlanCancel"
    >
      <a-form
        :form="editForm"
        @submit="editSubmit"
      >

        <a-form-item v-bind="formItemLayout">
          <span slot="label">要读的书</span>
          <a-select
            disabled
            showSearch
            placeholder="选择一本书"
            optionFilterProp="children"
            style="width: 310px"
            @focus="handleFocus"
            @blur="handleBlur"
            @change="handleChange"
            :filterOption="filterOption"
            v-decorator="['bookId',
            {initialValue: tempReadingPlan.bookId,
              rules: [{ required: true, message: '请选择一本书!'}],
            }]"
          >
            <a-select-option v-for="d in books" :key="d.id" :value="d.id">
              {{d.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">教师</span>
          <a-select
            showSearch
            placeholder="选择教师"
            optionFilterProp="children"
            style="width: 310px"
            @focus="handleFocus"
            @blur="handleBlur"
            @change="handleChange"
            :filterOption="filterOption"
            v-decorator="['teacherId',
            {initialValue: tempReadingPlan.teacherId,
              rules: [{ required: true, message: '请选择一名教师!'}],
            }]"
          >
            <a-select-option v-for="d in teachers" :key="d.id" :value="d.id">
              {{d.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="开始时间">
          <a-date-picker @change="changeStartTime"
                         style="width: 100%" placeholder="选择开始时间" v-decorator="['startTime',
                          {initialValue: moment(tempReadingPlan.startTime, dateFormat)}
                         ]" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="结束时间">
          <a-date-picker @change="changeEndTime"
                         style="width: 100%" placeholder="选择结束时间" v-decorator="['endTime',
                          {initialValue: moment(tempReadingPlan.endTime, dateFormat)}
                         ]" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">每个周期天数</span>
          <a-input-number  :min="1" :max="100" @change="cycleDaysChange"
                          v-decorator="['cycleDays',
            {initialValue: tempReadingPlan.cycleDays,
              rules: [{ required: true, message: '请选择每个周期天数!'}],
            }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">暂停周期数目</span>
          <a-input-number :min="0" :max="100"
                          @change="cycleDaysChange"
                          v-decorator="['pauseCycleCount',
            { initialValue: tempReadingPlan.pauseCycleCount,
              rules: [{ required: true, message: '请选择学习周期!'}],
            }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">反馈提示</span>
          <a-radio-group v-decorator="['notifyComment',
          {initialValue: tempReadingPlan.notifyComment == true ? 'true' : 'false',}
          ]">
            <a-radio-button value="true">
              是
            </a-radio-button>
            <a-radio-button value="false">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">班主任提示</span>
          <a-radio-group v-decorator="['adminMustComment',
          {initialValue: tempReadingPlan.adminMustComment  == true ? 'true' : 'false',}
          ]">
            <a-radio-button value="true">
              是
            </a-radio-button>
            <a-radio-button value="false">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">教师必须反馈</span>
          <a-radio-group v-decorator="['teacherMustComment',
          {initialValue: tempReadingPlan.teacherMustComment  == true ? 'true' : 'false',}
          ]">
            <a-radio-button value="true">
              是
            </a-radio-button>
            <a-radio-button value="false">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <!--<a-form-item v-bind="formItemLayout">-->
          <!--<span slot="label">助教IDS</span>-->
          <!--<a-input v-decorator="['otherNotifiers',-->
            <!--{initialValue: tempReadingPlan.otherNotifiers,-->
              <!--rules: [{ required: false, message: '请输入的助教ID!'}],-->
            <!--}-->
           <!--]"/>-->
        <!--</a-form-item>-->
        <a-form-item v-bind="formItemLayout">
          <span slot="label">自定义名称</span>
          <a-input v-decorator="['customizedName',
            {initialValue: tempReadingPlan.customizedName,
              rules: [{ required: false, message: '请输入的自定义名称!'}],
            }
           ]"/>
        </a-form-item>
        <!--<a-form-item v-bind="formItemLayout">-->
          <!--<span slot="label">退出学员ID</span>-->
          <!--<a-input v-decorator="['inactiveStudentIds',-->
            <!--{initialValue: tempReadingPlan.inactiveStudentIds,-->
              <!--rules: [{ required: false, message: '请输入的退出学员ID!'}],-->
            <!--}-->
           <!--]"/>-->
        <!--</a-form-item>-->
        <!--<a-form-item v-bind="formItemLayout">-->
          <!--<span slot="label">微信提示周期</span>-->
          <!--<a-input-number :min="0" :max="100"-->
                          <!--@change="cycleDaysChange"-->
                          <!--v-decorator="['wechatCycleDays',-->
            <!--{ initialValue: tempReadingPlan.wechatCycleDays,-->
              <!--rules: [{ required: true, message: '请选择微信提示周期!'}],-->
            <!--}]"-->
          <!--/>-->
        <!--</a-form-item>-->
        <!--<a-form-item v-bind="formItemLayout" label="微信提示时间">-->
          <!--<a-date-picker @change="changeWechatStartTime"-->
                       <!--style="width: 100%" placeholder="选
                       择提示开始时间" v-decorator="['wechatStartTime',-->
           <!--{initialValue: moment(tempReadingPlan.wechatStartTime, dateFormat)}]" />-->
        <!--</a-form-item>-->
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import store from '../store';

const columns = [{
  dataIndex: 'bookName',
  key: 'bookName',
  // slots: { title: '姓名' },
  // scopedSlots: { customRender: 'customTitle' },
  title: '书名',
  // fixed: 'left',
  // width: 300,
  // className: 'week-num-col',
},
{
  title: '教师',
  dataIndex: 'teacherName',
  key: 'teacherName',
  // width: '200px',
  // className: 'week-num-col',
},
{
  title: '状态',
  dataIndex: 'status',
  key: 'status',
  // width: '200px',
  // className: 'week-num-col',
  filters: [
    { text: '在读', value: '在读' },
    { text: '未开始', value: '未开始' },
    { text: '结束', value: '结束' },
  ],
  filteredValue: ['在读', '未开始'],
  onFilter: (value, record) => record.status.indexOf(value) === 0,
  scopedSlots: { customRender: 'status' },
},
{
  title: '开始时间',
  dataIndex: 'startTime',
  key: 'startTime',
  // width: '200px',
  // className: 'week-num-col',
},
{
  title: '结束时间',
  dataIndex: 'endTime',
  key: 'endTime',
  // width: '200px',
  // className: 'week-num-col',
},
// {
//   title: '服务时长',
//   dataIndex: 'serviceHours',
//   key: 'serviceHours',
//   className: 'column-service-hours',
//   scopedSlots: { customRender: 'serviceHours' },
// },
// {
//   title: '工作单位',
//   dataIndex: 'company',
//   key: 'company',
//   // className: 'week-num-col',
// },
// {
//   title: '手机',
//   dataIndex: 'mobile',
//   key: 'mobile',
//   // className: 'week-num-col',
// },
{
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' },
  // className: 'week-num-col',
}];
export default {
  name: 'User-manage',
  data() {
    return {
      initialValue1: ['admin', 'teacher'],
      tempUser: {},
      total: 0,
      users: [],
      columns,
      zhCN,
      tempVolunteer: '',
      dateString: '',
      startTimeString: '',
      endTimeString: '',
      wechatStartTimeString: '',
      volunteers: [],
      readingPlans: [],
      books: [],
      teachers: [],
      pageSize: 10,
      loading: true,
      addReadingPlanVisible: false,
      editReadingPlanVisible: false,
      confirmLoading: false,
      confirmDirty: false,
      autoCompleteResult: [],
      dateFormat: 'YYYY-MM-DD',
      width: 1,
      tempReadingPlan: {},
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.editForm = this.$form.createForm(this);
  },
  created() {
    this.hasVolunteerRole();
    // this.getUsersByPage(0, 10);
    // this.createTempUser();
    this.getAllReadingPlans();
  },
  methods: {
    moment,
    async getAllReadingPlans() {
      await this.axios({
        method: 'get',
        url: '/service/admin/readingplan/all',
      }).then((response) => {
        if (response.data.code === 0) {
          const tempReadingPlans = response.data.data;
          for (let i = 0; i < tempReadingPlans.length; i += 1) {
            // const key = 'key';
            const tempReadingPlan = tempReadingPlans[i];
            tempReadingPlan.key = i;
            this.readingPlans.push(tempReadingPlan);
          }
          this.loading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    setNaIfNull(value) {
      if (value === null) {
        return 'N/A';
      }
      return value;
    },

    showAddReadingPlanModal() {
      this.form = this.$form.createForm(this);
      this.getBooks();
      this.getTeachers();
      this.addReadingPlanVisible = true;
    },
    showEditReadingPlanModal(key) {
      this.editForm = this.$form.createForm(this);
      this.getReadingPlanById(this.readingPlans[key].readingPlanId);
      this.getBooks();
      this.getTeachers();
      this.startTimeString = null;
      this.endTimeString = null;
      this.editReadingPlanVisible = true;
    },
    toReaderDetail(key) {
      console.log(key);
      store.state.readingPlan = this.readingPlans[key];
      this.$router.push('/layout/reading-plan-reader-manage');
    },

    async downloadCert(key) {
      console.log(this.readingPlans[key]);
      const { readingPlanId } = this.readingPlans[key];
      await this.axios({
        method: 'get',
        url: `service/cert/create/${readingPlanId}`,
      }).then((response) => {
        if (response.data.code === 0) {
          this.$message.success(response.data.data);
          this.loading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    async downloadPdf(key) {
      console.log(this.readingPlans[key]);
      const { readingPlanId } = this.readingPlans[key];
      await this.axios({
        method: 'get',
        url: `service/admin/pdf/52weeks/download/${readingPlanId}`,
      }).then((response) => {
        if (response.data.code === 0) {
          this.$message.success(response.data.data);
          this.loading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    handleAddReadingPlanOk() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign
          values.startTime = this.startTimeString;
          // eslint-disable-next-line no-param-reassign
          values.endTime = this.endTimeString;
          // eslint-disable-next-line no-param-reassign
          values.wechatStartTime = this.wechatStartTimeString;
          console.log(values);
          const bookDto = {};
          const admin = {};
          bookDto.id = values.bookId;
          admin.userId = values.teacherId;
          // eslint-disable-next-line no-param-reassign
          values.bookDto = bookDto;
          // eslint-disable-next-line no-param-reassign
          values.admin = admin;
          console.log('Received values of form: ', values);
          this.axios({
            method: 'post',
            url: 'service/admin/readingplan/submit',
            data: values,
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message.success('添加读书计划成功', 1);
              // this.$router.push('/layout/book-card');

              this.addReadingPlanVisible = false;
              this.readingPlans = [];
              this.getAllReadingPlans();
            } else {
              this.$message.error(response.data.msg);
            }
          }).catch((response) => {
            console.log(response.data);
          });
        }
      });
    },
    handleEditReadingPlanOk() {
      this.editForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign,max-len
          values.startTime = this.startTimeString === null ? this.tempReadingPlan.startTime : this.startTimeString;
          // eslint-disable-next-line no-param-reassign,max-len
          values.endTime = this.endTimeString === null ? this.tempReadingPlan.endTime : this.endTimeString;
          // eslint-disable-next-line max-len,no-param-reassign
          values.wechatStartTime = this.wechatStartTimeString === null ? this.tempReadingPlan.wechatStartTime : this.wechatStartTimeString;
          // eslint-disable-next-line no-param-reassign
          values.readingPlanId = this.tempReadingPlan.readingPlanId;
          const bookDto = {};
          const admin = {};
          bookDto.id = values.bookId;
          admin.userId = values.teacherId;
          // eslint-disable-next-line no-param-reassign
          values.bookDto = bookDto;
          // eslint-disable-next-line no-param-reassign
          values.admin = admin;
          console.log('Received values of form: ', values);
          this.axios({
            method: 'post',
            url: 'service/admin/readingplan/submit',
            data: values,
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message.success('计划更新成功', 1);
              // this.$router.push('/layout/book-card');
              this.editReadingPlanVisible = false;
              this.readingPlans = [];
              this.getAllReadingPlans();
            } else {
              this.$message.error(response.data.msg);
            }
          }).catch((response) => {
            console.log(response.data);
          });
        }
      });
    },
    hasVolunteerRole() {
      if (store.state.user.roles.indexOf('VADMIN') < 0) {
        this.$router.push('/layout/book-card');
      }
    },
    changeStartTime(date, dateString) {
      this.startTimeString = dateString;
      console.log(dateString);
    },
    changeEndTime(date, dateString) {
      this.endTimeString = dateString;
      console.log(dateString);
    },
    changeWechatStartTime(date, dateString) {
      this.wechatStartTimeString = dateString;
      console.log(dateString);
    },
    handleAddReadingPlanCancel() {
      console.log('Clicked cancel button');
      this.addReadingPlanVisible = false;
    },
    handleEditReadingPlanCancel() {
      console.log('Clicked cancel button');
      this.editReadingPlanVisible = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    editSubmit(e) {
      e.preventDefault();
      this.editForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleConfirmBlur(e) {
      const { value } = e.target;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const { form } = this;
      if (value && value !== form.getFieldValue('password')) {
        callback('Two passwords that you enter is inconsistent!');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const { form } = this;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
    handleWebsiteChange(value) {
      let autoCompleteResult;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map(domain => `${value}${domain}`);
      }
      this.autoCompleteResult = autoCompleteResult;
    },
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    handleBlur() {
      console.log('blur');
    },
    tableChange(pagination, filters, sorter) {
      console.log('Various parameters', pagination, filters, sorter);
    },
    handleFocus() {
      console.log('focus');
    },
    cycleDaysChange() {

    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    async getBooks() {
      await this.axios({
        method: 'get',
        url: '/service/admin/readingplan/allBook',
      }).then((response) => {
        if (response.data.code === 0) {
          this.books = response.data.data;
          console.log(this.books.length);
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    async getTeachers() {
      await this.axios({
        method: 'get',
        url: '/service/admin/readingplan/allTeacher',
      }).then((response) => {
        if (response.data.code === 0) {
          this.teachers = response.data.data;
          console.log(this.teachers.length);
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    async getReadingPlanById(id) {
      await this.axios({
        method: 'get',
        url: `/service/admin/readingplan/get/${id}`,
      }).then((response) => {
        if (response.data.code === 0) {
          this.tempReadingPlan = response.data.data;
          this.tempReadingPlan.bookId = this.tempReadingPlan.bookDto.id;
          this.tempReadingPlan.teacherId = this.tempReadingPlan.admin.id;
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
  },
};

</script>

<style scoped>
  .table-space {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  /*.table-content{*/
  /*  margin-top: 20px;*/
  /*}*/
  .add-button {
    float: left;
  }
  .search-input{
    float: right;
  }
  .table-footer {
    margin-top: 10px;
    float: right;
  }
  @media (min-width: 576px){
    .ant-col-sm-8 {
      width: 28.33333333% !important;
    }
  }
  .table-header{
    margin-top: 20px;
    height: 40px;
  }
</style>
